import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: 'VITE_',

  client: {
    VITE_APP_TITLE: z.string().min(1).optional(),
    VITE_BASE_URL: z.string().url(),
    VITE_BASE_URL_VISIT_ENGINE: z.string().url(),
    VITE_SSO_AUTHORIZE_URL: z.string().url(),
    VITE_SSO_CLIENT_ID: z.string().min(1),
    VITE_SSO_REDIRECT_URI: z.string().url(),
    VITE_SSO_SCOPE: z.string().min(1).optional(),
    VITE_IS_MAINTANANCE: z.enum(['true', 'false']).optional(),
    VITE_ALERT_TITLE: z.string().min(1).optional(),
    VITE_ALERT_DESCRIPTION: z.string().min(1).optional(),
    VITE_ALERT_STATUS: z
      .enum(['info', 'warning', 'success', 'error'])
      .optional(),
  },

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   *
   * This means that if you have an empty string for a value that is supposed
   * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
   * it as a type mismatch violation. Additionally, if you have an empty string
   * for a value that is supposed to be a string with a default value (e.g.
   * `DOMAIN=` in an ".env" file), the default value will never be applied.
   *
   * In order to solve these issues, we recommend that all new projects
   * explicitly specify this option as true.
   */
  emptyStringAsUndefined: true,
})

export const isMaintenanceMode = env.VITE_IS_MAINTANANCE
export const envAlertTitle = env.VITE_ALERT_TITLE
export const envAlertDescription = env.VITE_ALERT_DESCRIPTION
export const envAlertStatus = env.VITE_ALERT_STATUS
